import { render, staticRenderFns } from "./add-investigation-documents.vue?vue&type=template&id=65852cde&"
import script from "./add-investigation-documents.vue?vue&type=script&lang=js&"
export * from "./add-investigation-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports